import { z } from 'zod'

export const businessSchema = z.object({
  name: z.string().min(2),
  slug: z.string().min(2).regex(/^[a-z0-9-]+$/),
  categoryId: z.string().uuid('Category required'),
  country: z.string().optional(),
  city: z.string().optional(),
  address: z.string().optional(),
  phone: z.string().optional(),
  website: z.string().url().optional().or(z.literal('')),
  email: z.string().email().optional().or(z.literal('')),
  instagram: z.string().optional(),
  hours: z.string().optional(),
  description: z.string().max(2000).optional(),
  mapLink: z.string().url().optional().or(z.literal('')),
  featured: z.boolean().default(false),
  sponsored: z.boolean().default(false),
  ourPick: z.boolean().default(false),
  onlineOnly: z.boolean().default(false),
  isActive: z.boolean().default(true),
})

export const categorySchema = z.object({
  slug: z.string().min(2).regex(/^[a-z0-9-]+$/),
  label: z.string().min(1).max(200),
  icon: z.string().optional(),
  color: z.string().optional(),
  order: z.coerce.number().int().min(0),
  isActive: z.boolean().default(true),
})

export const serviceSchema = z.object({
  title: z.string().min(1).max(200),
  slug: z.string().min(2).regex(/^[a-z0-9-]+$/),
  icon: z.string().optional(),
  gradient: z.string().optional(),
  description: z.string().optional(),
  price: z.string().optional(),
  order: z.coerce.number().int().min(0),
  isActive: z.boolean().default(true),
})

export const pricingPlanSchema = z.object({
  name: z.string().min(1).max(100),
  price: z.string().min(1).max(50),
  period: z.string().optional(),
  badge: z.string().optional(),
  isHighlighted: z.boolean().default(false),
  description: z.string().min(1).max(500),
  ctaText: z.string().min(1).max(100),
  ctaHref: z.string().min(1).max(300),
  order: z.coerce.number().int().min(0),
  isActive: z.boolean().default(true),
})

export const faqItemSchema = z.object({
  question: z.string().min(5).max(500),
  answer: z.string().min(5).max(2000),
  order: z.coerce.number().int().min(0),
  isActive: z.boolean().default(true),
})

export const locationSchema = z.object({
  country: z.string().min(2).max(100),
  city: z.string().min(2).max(100),
  countryLabel: z.string().min(2).max(200),
  cityLabel: z.string().min(2).max(200),
  flag: z.string().optional(),
})
